// extracted by mini-css-extract-plugin
export var arrows = "_26-6";
export var decrementer = "_26-a";
export var disabled = "_26-4";
export var error = "_26-1";
export var hiddenText = "_26-b";
export var incrementer = "_26-9";
export var input = "_26-8";
export var inputWrapper = "_26-0";
export var leadingIcon = "_26-c";
export var readonly = "_26-3";
export var regular = "_26-7";
export var small = "_26-5";
export var warning = "_26-2";